import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { usePrevious } from 'estimate_list/utils/usePrevious'
import {
    SELECT_CATEGOTY,
    SET_ROUTE,
    SET_INIT_ROUTE,
    initialState,
    SET_SELECTED_FILTER,
    SET_FILTER_OPTION_ALL,
    SET_SERVICE_OS_LIST
} from 'estimate_list/reducers/initial'

import FilterFinder from '../../components/filter'
import Tab from '../tab'
import SubNav from '../../components/subnav'
import SmartViewSV from 'estimate_list/components/smartViewSV'
import PowerClick from 'estimate_list/components/powerClick'
import NaverPowerLink from 'estimate_list/components/naverPowerLink'
import NaverPowerShopping from 'estimate_list/components/naverPowerShopping'
import {serviceAPI} from "../../components/api/common";
import SEO from "../../libs/seo";
// import {scrollTo} from "../../libs/util";

const Index = (props) => {
    const { domain, selectCategory, loading, setSearchDataOption } = useSelector(state => state.initial)
    const categoryData = useSelector(state => state.category.categoryData)
    // const objCateData = useSelector((state) => state.category.objCateData)
    const [searchDataFirstLoad, setSearchDataFirstLoad] = useState(false)
    const [isNaverLoadingEnd,setIsNaverLoadingEnd] = useState(false)

    const dispatch = useDispatch()
    const match = useRouteMatch()
    const prevCategory = usePrevious(selectCategory)
    const prevLoadingSetSearchDataOption = usePrevious(loading.setSearchDataOption)

    // const [osList, setOsList] = useState([])

    useEffect(async () => {
        const {data} = await serviceAPI.getOsListWithOsInstall()
        // setOsList(data.result.curation[0].items.map(item => String(item.item_id)))
        dispatch({
            type: SET_SERVICE_OS_LIST,
            data : data.result.curation[0].items.map(item => String(item.item_id))
        })
    }, [])


    useEffect(() => { // category 변경시 default 세팅
        if (prevCategory) { // 이전카테고리 처음상태: undefined - 처음 category 변경시엔 실행안함
            dispatch({
                type: SET_ROUTE,
                data: { ...initialState.route }
            })
            dispatch({
                type: SET_SELECTED_FILTER,
                data: initialState.selectedFilters
            })
            dispatch({
                type: SET_FILTER_OPTION_ALL,
                data: false
            })
        }
    }, [selectCategory]) // eslint-disable-line

    useEffect(() => { // match redux 맞추기 -> match 변경시 redux에 값 넣기
        if (prevCategory === match.params.categoryID) return
        if (match.params.categoryID) {
            dispatch({
                type: SELECT_CATEGOTY,
                data: match.params.categoryID
            })
        }
    }, [match.params.categoryID]) // eslint-disable-line

    useEffect(() => { // match redux 맞추기 -> match 변경시 redux에 값 넣기
        if (match.params.tab) {
            dispatch({
                type: SET_ROUTE,
                data: { tab: match.params.tab }
            })
        }
    }, [match.params.tab]) // eslint-disable-line

    useEffect(() => { // match redux 맞추기 -> 초기값 redux에 값 넣기
        const urlRoute = { ...match.params }
        delete urlRoute.categoryID
        delete urlRoute.minishopName

        dispatch({
            type: SELECT_CATEGOTY,
            data: match.params.categoryID
        })
        if (urlRoute.srch_cond === 'null') {
            urlRoute.srch_cond = null
        }
        if (urlRoute.tab !== 'total') { // 리스트 관련 아닌 속성 삭제
            delete urlRoute.types
            delete urlRoute.page
            delete urlRoute.sort
            delete urlRoute.size
            delete urlRoute.srch_cond
        }
        dispatch({
            type: SET_ROUTE,
            data: { ...urlRoute }
        })
        setTimeout(() => {
            dispatch({
                type: SET_INIT_ROUTE,
            })
        }, 10)
    }, []) // eslint-disable-line

    useEffect(() => {
        if (prevLoadingSetSearchDataOption && setSearchDataOption.makerList) {
            setSearchDataFirstLoad(true)
        }
        if(searchDataFirstLoad && isNaverLoadingEnd){
            props.setIsIndexLoading(false)
            // setIsNaverLoading(true)
        }
    }, [loading.setSearchDataOption]) // eslint-disable-line

    useEffect(() => { // match redux 맞추기 -> 초기값 redux에 값 넣기
        urlSpecDecode()
        if (searchDataFirstLoad) {
            urlSpecDecode()
        }
    }, [searchDataFirstLoad]) // eslint-disable-line

    const urlSpecDecode = () => {   // url spec 값을 redux에 세팅
        const { makerData, specData } = setSearchDataOption
        let specReduce = {
            maker: [],
            spec: {},
            kwd: '',
            min: 0,
            max: 0,
        }
        const urlRoute = { ...match.params }
        const srchCond = decodeURIComponent(urlRoute.srch_cond)
        const params = new URLSearchParams(srchCond)

        if (params.get('maker')) {
            params.get('maker').split(',').forEach(v => {
                if (!makerData?.[v]) {
                    specReduce.maker.push({ maker_id: +v, maker_name: '-' })
                } else {
                    specReduce.maker.push({ maker_id: +v, maker_name: makerData[v].makerName })
                }
            })
        }
        if (params.get('spec')) {
            const arr = params.get('spec').split(' ')
            const specTrans = {}
            arr.forEach(v => {
                const key = v.substring(v.lastIndexOf('K') + 1, v.lastIndexOf('V'))
                const valueArr = v.split('V')[1].split('|')
                if (!valueArr[0]) return
                specTrans[key] = []
                valueArr.forEach(v => {
                    specTrans[key].push({ specNameKey: +key, specValueKey: +v, specValue: (specData?.[v]?.specNameValue || '-') + ' : ' + (specData?.[v]?.specSelValue || '-') })
                })
            })
            specReduce.spec = specTrans
        }
        if (params.get('keyword')) {
            specReduce.kwd = params.get('keyword')
        }
        if (params.get('min')) {
            specReduce.min = +params.get('min')
        }
        if (params.get('max')) {
            specReduce.max = +params.get('max')
        }
        dispatch({
            type: SET_SELECTED_FILTER,
            data: specReduce
        })
    }

    return (
        <>
            {props.cateName != null && (
                ((domain === 'shopping') && (
                    <>
                        {(match.path === '/list/:categoryID') && (
                            <SEO
                                title={`${props.cateName} : 행복쇼핑 가격비교`}
                                description={`${props.cateName} : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                ogTitle={`${props.cateName} : 행복쇼핑 가격비교`}
                                ogSiteName={`${props.cateName} : 행복쇼핑 가격비교`}
                            />
                        )}
                    </>
                ))
            )}

            {domain && selectCategory && (
                (categoryData.length === 0 || !searchDataFirstLoad)
                    ? <Loading />
                    : <FilterFinder />)
            }
            <NaverPowerShopping setIsNaverLoadingEnd={setIsNaverLoadingEnd} />
            <Layout domain={domain} id="layout_list_group">
                {(domain !== 'shopping' && categoryData.length > 0) && <SubNav  setIsScroll={props.setIsScroll}/>}
                <Tab cateName={props.cateName}/>
            </Layout>
            <SmartViewSV />
            <NaverPowerLink />
            <PowerClick />
        </>
    )
}

export const Loading = () => {
    return <Load><img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/happy_loading_5.gif`} alt="" width="60" height="69" /></Load>
}

Index.prototypes = {
    match: PropTypes.object
}

const Layout = styled.div`
    position: relative;
    padding: ${props => props.domain !== 'shopping' ? '0 0 0 60px' : 0};
    z-index: 20;
`

const Load = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 295px;
    margin: 0 0 50px;
`

export default Index



// WEBPACK FOOTER //
// ./src/estimate_list/pages/index/index.js